module.exports = __webpack_public_path__ + "img/hotelBg4.aa97a3cd.png";